export const clockOffsetMs = (serverNowIso: string, receivedAtMs: number): number =>
    Date.parse(serverNowIso) - receivedAtMs;

export const secondsLeft = (endsAtIso: string | null, nowMs: number, offsetMs: number): number =>
    endsAtIso ? Math.max(0, Math.ceil((Date.parse(endsAtIso) - (nowMs + offsetMs)) / 1000)) : 0;

export const formatClock = (seconds: number): string =>
    `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
